// extracted by css-extract-rspack-plugin
export default {"headerToggleOnly":"HeaderToggleOnly-module__headerToggleOnly__WuYoD"};